import { validateEmail, CheckPassword } from '../utilities/utility';
const $doc = $(document);
const signInButton = '#signInButton';
const createAccountOverlay = '#createAccountOverlay';
const guestOverlay = '#guestOverlay';
const createBtn = '.create-btn';
const guestBtn = '.guest-btn';
const ssecondarySgnInBtn = '.sign-in-btn';
const productCategory = '.product-category';
const formInput = '#cboxLoadedContent .form-group input';
const emailErrorMsg = '.coexistence-overlay .error-msg-text-email';
const emptyEmailErrorMsg = '.coexistence-overlay .error-msg-empty-email';
const pwdErrorMsg = '.coexistence-overlay .error-msg-text-pass';
const errorMsg = '.coexistence-overlay .error-msg-text';
const createGuestOverlay = '.create-account-guest-overlay';
const signOverlay = '.coexistence-overlay-section';
const guestButton = '.guest-btn';
const accountButton = '.create-btn';
const accountSection = '.create-account-tag';
const guestSection = '.browse-guest-tag';
const overlayClass = 'coexistence-overlay';
const userInput = '#cboxLoadedContent #j_username_coexistence';
const passwordInput = '#cboxLoadedContent #j_password_coexistence';
const signInBtnDisable = '#cboxLoadedContent #signInButton';
const cartOverlay = 'coexistence-cart-overlay-class';
const okButton = '.coexistence-cart-overlay-class .ok-btn';
const legacyRedirectionFlag = $('#legacyRedirectionFlag').val();
const bpLegacyRedirectionFlag = $('#bpLegacyRedirectionFlag').val();
const diabeticCreateAccount = '.diabetic-category';
const breastPumpCreateAccount = '.breastpump-category';
const legacyRegisterUrl = $('#legacyRegisterUrl').val();
const showMsgDetail = '.read-more-detail';
const errorMsgDetail = '.detailed-error-msg';

let cboxOptions;
let searchParamPreregistered = new URLSearchParams(window.location.search);
if ($('#showOverlay').val() === 'true') {
  cboxOptions = {
    maxWidthLg: '513px',
    maxHeightLg: '585px',
    maxWidthMd: '513px',
    maxHeightMd: '585px',
    maxWidthSm: '360px',
    maxHeightSm: '596px'
  };
} else if ($('#showCartPopUp').val() === 'true') {
  cboxOptions = {
    maxWidthLg: '694px',
    maxHeightLg: '666px',
    maxWidthMd: '527px',
    maxHeightMd: '666px',
    maxWidthSm: '348px',
    maxHeightSm: '912px'
  };
}

const coexistence = {
  checkWidth() {
    if (window.innerWidth >= 1368) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  },
  checkHeight() {
    if (window.innerHeight >= 1368) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 1368) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  },
  displayColorBox() {
    if (
      $('#redirectionSource').length > 0 &&
      $('#redirectionSource').val() === 'email'
    ) {
      $('.header-signin')[0].click();
    } else {
      if (
        $('#showOverlay').val() === 'true' &&
        !searchParamPreregistered.get('preRegistered') &&
        $('#showOktaTokenExpire').val() !== 'true' &&
        $('#showOktaTokenNotification').val() !== 'true'
      ) {
        ACC.colorbox.open('', {
          escKey: false,
          overlayClose: false,
          closeButton: false,
          html: $('#coexistence-signin-overlay').html(),
          onLoad: $('#cboxOverlay').css('position', 'fixed'),
          width: coexistence.checkWidth(),
          height: coexistence.checkHeight(),
          className: overlayClass
        });
        $('.hide-signIn-dropdown').hide();
      }
      if (
        $('#showCartPopUp').val() === 'true' &&
        !searchParamPreregistered.get('preRegistered') &&
        $('#showOktaTokenExpire').val() !== 'true' &&
        $('#showOktaTokenNotification').val() !== 'true'
      ) {
        ACC.colorbox.open('', {
          escKey: false,
          overlayClose: false,
          closeButton: false,
          html: $('#coexistence-cart-overlay').html(),
          onLoad: $('#cboxOverlay').css('position', 'fixed'),
          width: coexistence.checkWidth(),
          height: coexistence.checkHeight(),
          className: cartOverlay
        });
      }
    }
  },
  displayCreateAccount() {
    $(createGuestOverlay).removeClass('hidden');
    $(signOverlay).addClass('hidden');
    $(guestButton).removeClass('hidden');
    $(accountButton).addClass('hidden');
    $(accountSection).removeClass('hidden');
    $(guestSection).addClass('hidden');
    if (legacyRedirectionFlag === 'true') {
      $(diabeticCreateAccount).attr('href', legacyRegisterUrl);
    }
    if (bpLegacyRedirectionFlag === 'true') {
      $(breastPumpCreateAccount).attr('href', legacyRegisterUrl);
    }
  },
  displayGuest() {
    $(createGuestOverlay).removeClass('hidden');
    $(signOverlay).addClass('hidden');
    $(guestButton).addClass('hidden');
    $(accountButton).removeClass('hidden');
    $(accountSection).addClass('hidden');
    $(guestSection).removeClass('hidden');
  },
  displaySignInOverlay() {
    $(createGuestOverlay).addClass('hidden');
    $(signOverlay).removeClass('hidden');
  },
  enableSignin() {
    if ($(userInput).val() === '' || $(passwordInput).val() === '') {
      $(signInBtnDisable).prop('disabled', true);
    } else {
      $(signInBtnDisable).prop('disabled', false);
    }
  },

  validateInputs(e) {
    const isEmailValid = validateEmail('.coexistence-overlay .co-email');
    const isPwdValid = CheckPassword('.coexistence-overlay .co-password');
    $(errorMsg).addClass('hidden');
    if (isEmailValid !== true) {
      e.preventDefault();
      $(emailErrorMsg).removeClass('hidden');
      $(pwdErrorMsg).addClass('hidden');
      $.colorbox.resize();
      return;
    } else if (isPwdValid !== true) {
      e.preventDefault();
      $(emailErrorMsg).addClass('hidden');
      $(pwdErrorMsg).removeClass('hidden');
      $.colorbox.resize();
    } else {
      $(errorMsg).addClass('hidden');
      $.colorbox.resize();
    }
    $.colorbox.resize();
  },
  showErrorMsgDetail(e) {
    $(errorMsgDetail).slideToggle();
    if ($(this).text() == "Read More") { 
      $(this).text("See Less").addClass('expanded');
    } else {
      $(this).text("Read More").removeClass('expanded');
    }
    $.colorbox.resize();
  },
  validateEmailOnInput(e) {
    const isEmailValid = validateEmail('.coexistence-overlay .co-email');
    $(errorMsg).addClass('hidden');
    if (isEmailValid !== true) {
      e.preventDefault();
      $(emailErrorMsg).removeClass('hidden');
      $(pwdErrorMsg).addClass('hidden');
      return;
    } else if (
      $(userInput)
        .val()
        .trim() === ''
    ) {
      $(emptyEmailErrorMsg).removeClass('hidden');
    } else {
      $(emailErrorMsg).addClass('hidden');
      $(emptyEmailErrorMsg).addClass('hidden');
    }
  },

  enableCookie() {
    let date = new Date();
    let minutes = 60;
    date.setTime(date.getTime() + minutes * 60 * 1000);
    $.cookie('guestoverlayvisited', 'VISITED', { path: '/', expires: date });
  },

  redirectUrl(e) {
    let legacySiteCategories = $('#legacySiteCategories')
      .val()
      .split(',');
    /* redirect to EPBPICON url from bp products, hence added this code*/
    if (
      $(this).text() === $('.breastpump-browse-guest').attr('aria-label') &&
      bpLegacyRedirectionFlag === 'true'
    ) {
      window.open($('#bpRedirectionUrl').val(), '_self');
      return false;
    }
    if (
      legacySiteCategories.indexOf($(this).text()) === -1 ||
      ($(this).text() === $('.breastpump-browse-guest').attr('aria-label') &&
        bpLegacyRedirectionFlag === 'false')
    ) {
      window.location.href = '/breast-pumps-and-supplies/c/L1-23';
      return false;
    } else {
      const url = window.location.href;
      const legacyUrl = $('#mainLegacyUrl').val();
      coexistence.commonRedirection(url, legacyUrl);
    }
  },
  redirectUrlFromCart() {
    const url = $('#refererUrl').val();
    window.open(url, '_self');
    $.colorbox.close();
  },

  commonRedirection(url, legacyUrl) {
    let data;
    if (url.indexOf('/p/') !== -1 || url.indexOf('/search/') !== -1) {
      data = url.split('/');
      data =
        legacyUrl + '/' + data[data.length - 2] + '/' + data[data.length - 1];
    } else if (url.indexOf('/c/') !== -1) {
      data = url.split('/');
      data = legacyUrl + 'c/' + data[data.length - 1];
    } else {
      data = legacyUrl;
    }
    window.open(data, '_self');
  },
  redirectToHome() {
    setTimeout(function() {
      const currentUrl = window.location;
      const url = window.location.href;
      const baseUrl =
        currentUrl.protocol + '//' + currentUrl.host + '/chhextsamlsinglesignon/saml';
      if ($.cookie('sessionId') != null) {
        coexistence.commonRedirection(url, baseUrl);
        $.colorbox.close();
      }
    }, 7000);
  },
  init() {
    this.displayColorBox();
    $doc.on('click', signInButton, this.validateInputs);
    $doc.on('click', createAccountOverlay, this.displayCreateAccount);
    $doc.on('click', guestOverlay, this.displayGuest);
    $doc.on('click', createBtn, this.displayCreateAccount);
    $doc.on('click', guestBtn, this.displayGuest);
    $doc.on('click', ssecondarySgnInBtn, this.displaySignInOverlay);
    $doc.on('click', productCategory, this.enableCookie);
    $doc.on('input', formInput, this.enableSignin);
    $doc.on('click', '.product-browse-guest', this.redirectUrl);
    $doc.on('click', signInBtnDisable, this.redirectToHome);
    $doc.on('click', okButton, this.redirectUrlFromCart);
    $doc.on('blur', userInput, this.validateEmailOnInput);
    $doc.on('click', showMsgDetail, this.showErrorMsgDetail);
   
  }
};

$doc.ready(function() {
  coexistence.init();
});



export default coexistence;
